import controller from './buy-success-dialog.controller';

export default {
  controller,
  template: require('./buy-success-dialog.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/components/buy-success-dialog/buy-success-dialog.component.ts